module.exports = __webpack_public_path__ + "img/gc_country_flag_uy.69d34852.svg";